import React from 'react'
import { connect } from 'react-redux'
import { Icon } from 'semantic-ui-react'
import ReactTable from 'react-table'
import { getFormValues, reduxForm } from 'redux-form'

import { 
  MainBodyContent,
  SearchList,
  TablePagination
} from 'components'
import { 
  trackingDetailPath,
} from 'routes'
import {
  columns
} from './AttributeData'
import { 
  fetchTrackings,
  setTrackingDetail,
} from 'ducks/tracking'

import { TrackingListCont } from './styled'
import { ProcurementContainer, ProcurementBody } from '../styled'

const TrackingList = (props) => {

  const { 
    trackingList,
    valueForm 
  } = props

  const userPageSize = parseInt(localStorage.getItem('userPageSize') || '10')
  const [pageSize, setPageSize] = React.useState(userPageSize)

  React.useEffect(() => {
    props.fetchTrackings()
  },[])

  return (
    <MainBodyContent headerTitle="Tracking">
      <ProcurementContainer>
        <ProcurementBody>
          <SearchList pageSize={pageSize} placeholder='PO Doc No., Title, Requester' fetchAPI={props.fetchTrackings} formSearchName='formSearchTracking'/>
          <TrackingListCont>
            <ReactTable 
              data={Object.keys(trackingList).length>0?trackingList.data:[]}
              columns={columns.tPOUs}
              defaultPageSize={userPageSize}
              noDataText="No Tracking found"
              previousText={<Icon name="arrow alternate circle left" />}
              nextText={<Icon name="arrow alternate circle right" />}
              className="-striped -highlight"

              PaginationComponent={TablePagination}
              pages={Object.keys(trackingList).length>0?trackingList.totalPage:0}
              currentPage={Object.keys(trackingList).length>0?trackingList.page:0}
              onPageChange={(pageIndex) => {
                props.fetchTrackings({...valueForm,page:pageIndex+1,size:pageSize})
              }}
              onPageSizeChange={(pageSize, pageIndex) => {
                setPageSize(pageSize)
                localStorage.setItem('userPageSize', pageSize)
                props.fetchTrackings({...valueForm,page:pageIndex+1,size:pageSize})
              }}
              
              getTdProps={(state, rowInfo, column, instance) => {
                return {
                  onClick: (e, handleOriginal) => {
                    if (rowInfo && column && column.Header !== '') {
                      props.setTrackingDetail(rowInfo.original)
                      window.open(trackingDetailPath(rowInfo.original.id))
                    }
                    if (handleOriginal) {
                      handleOriginal()
                    }
                  },
                }
              }}
            />
          </TrackingListCont>
        </ProcurementBody>
      </ProcurementContainer>
    </MainBodyContent>
  )
}

const mapStateToProps = state => ({
  trackingList: state.tracking.trackingList,
  valueForm: getFormValues('formSearchTracking')(state),
})

const mapDispatchToProps = {
  fetchTrackings,
  setTrackingDetail,
}

const contForm = reduxForm({
  form: 'formSearchTracking',
  enableReinitialize: true,
})(TrackingList)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)
